import React, { useState } from "react";
import styles from "./Recipe.module.css";
import StepsComponent from "../../../../../components/StepsComponent/StepsComponent";
import SubmitButton from "../../../../../components/submitButton/SubmitButton";
import TextComponent from "../../../../../components/textComponent/TextComponent";
import { Table } from "antd";

const RecipeComponent = () => {
  const steps = ["Mixing", "Make Up", "Chilling", "Proofing"];
  const [current, setCurrent] = useState(0);
  const [selectedBtn, setselectedBtn] = useState("btn1");

  const basicInfoData = {
    "Process Name": "Apprentice",
    "Process Time": "2:30 Pm",
  };
  const methodData = {
    "Machine Used": "Brick Oven",
    Parameters: "",
    Time: "2:30 Pm",
    Temperature: "25°C",
  };
  const additionalData = {
    Time: "2:30 Pm",
  };
  const instructionsData = {
    "01": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "02": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "03": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "04": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "05": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "06": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "07": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "08": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "09": "prep Cambro with canola oil, 11.3Kg max dough per container",
  };

 const finishedColumn = [
    {
      title: "",
      dataIndex: "label",
      key: "label",
       render: (text) => <strong>{text}</strong>,
    },
    {
      title: "",
      key: "type",
      dataIndex: "type",
    },
     {
      title: "",
      key: "value",
      dataIndex: "value",
    },
  ];

  const finishedData = [
    {
      label: "Bake Temperature (Fahrenheit)",
      type: "Numeric",
      value: "45",
    },
    {
      label: "Time (minutes)",
      type: "Numeric",
      value: "20",
    },
    // "Bake Temperature (Fahrenheit)": "45",
    // "Time (minutes)": "20",
  ];

  console.log("current --> ", steps);

  return (
    <>
      <div className={styles.stepsComp}>
        <StepsComponent
          steps={steps}
          currentStepIndex={current}
          onPrev={() => setCurrent((c) => Math.max(0, c - 1))}
          onNext={() => setCurrent((c) => Math.min(steps.length - 1, c + 1))}
        />
      </div>
      <div className={styles.mainCont}>
        <div className={styles.HeaderRow}>
          <div>
            {current == 0 ? (
              <TextComponent
                className={styles.Heading}
                text={"Sourdough Dough Mix (MIX-SD-BASE)"}
              />
            ) :
              current == 1 ?
                (
                  <TextComponent
                    className={styles.Heading}
                    text={"Batard Shaping (MAKEUP-BATARD)"}
                  />
                ) :
                current == 2 ?
                  (
                    <TextComponent
                      className={styles.Heading}
                      text={"Batard Chilling (CHILLING-BATARD)"}
                    />
                  )
                  : (
                    <TextComponent
                      className={styles.Heading}
                      text={"Standard Proof (PROOF-SD-2HR)"}
                    />
                  )
            }
          </div>

          <div className={styles.buttonsDiv}>
            <SubmitButton
              title={"Stage 1"}
              primary={selectedBtn === "btn1" ? true : false}
              onClick={() => setselectedBtn("btn1")}
              btnContainerClass={styles.stageBtn}
              btnClass={styles.btn}
              textClass={styles.finishedBtnTxt}
            />
            <SubmitButton
              title={"Stage 2"}
              primary={selectedBtn === "btn2" ? true : false}
              onClick={() => setselectedBtn("btn2")}
              btnContainerClass={styles.stageBtn}
              btnClass={styles.btn}
              textClass={styles.finishedBtnTxt}
            />
            <SubmitButton
              title={"Finished Process Parameters"}
              primary={selectedBtn === "btn3" ? true : false}
              onClick={() => setselectedBtn("btn3")}
              btnContainerClass={styles.finishedBtn}
              btnClass={styles.btn}
              textClass={styles.finishedBtnTxt}
            />
          </div>
        </div>

        <div className={styles.parentCont}>
          {selectedBtn === "btn1" && (
            <>
              <div className={styles.leftCont}>
                <div className={styles.box}>
                  <TextComponent
                    className={styles.Heading}
                    text={"Basic Information"}
                  />
                  <div className={styles.itemsList}>
                    {Object.entries(basicInfoData).map(([label, value]) => {
                      const formattedLabel = label.replace(/_/g, " ");
                      return (
                        <div className={styles.row}>
                          <TextComponent
                            className={styles.label}
                            text={`${formattedLabel} :`}
                          />
                          <TextComponent
                            className={styles.value}
                            text={value || "-"}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className={styles.box}>
                  <TextComponent className={styles.Heading} text={"Method"} />
                  <div className={styles.itemsList}>
                    {Object.entries(methodData).map(([label, value]) => {
                      const formattedLabel = label.replace(/_/g, " ");
                      return (
                        <div className={styles.row}>
                          <TextComponent
                            className={styles.label}
                            text={`${formattedLabel} :`}
                          />
                          <TextComponent
                            className={styles.value}
                            text={value || "-"}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className={styles.box}>
                  <TextComponent
                    className={styles.Heading}
                    text={"Additional Parameter"}
                  />
                  <div className={styles.itemsList}>
                    {Object.entries(additionalData).map(([label, value]) => {
                      const formattedLabel = label.replace(/_/g, " ");
                      return (
                        <div className={styles.row}>
                          <TextComponent
                            className={styles.label}
                            text={`${formattedLabel} :`}
                          />
                          <TextComponent
                            className={styles.value}
                            text={value || "-"}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className={styles.rightCont}>
                <div className={styles.box}>
                  <TextComponent
                    className={styles.Heading}
                    text={"Instructions"}
                  />
                  <div className={styles.itemsList}>
                    {Object.entries(instructionsData).map(([label, value]) => {
                      const formattedLabel = label.replace(/_/g, " ");
                      return (
                        <div className={styles.inLineRow}>
                          <TextComponent
                            className={styles.instructionslabel}
                            text={`${formattedLabel} `}
                          />
                          <TextComponent
                            className={styles.instructionsvalue}
                            text={value || "-"}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <div className={styles.parentCont}>
          {selectedBtn === "btn2" && (
            <>
              <div className={styles.leftCont}>
                <div className={styles.box}>
                  <TextComponent
                    className={styles.Heading}
                    text={"Basic Information"}
                  />
                  <div className={styles.itemsList}>
                    {Object.entries(basicInfoData).map(([label, value]) => {
                      const formattedLabel = label.replace(/_/g, " ");
                      return (
                        <div className={styles.row}>
                          <TextComponent
                            className={styles.label}
                            text={`${formattedLabel} :`}
                          />
                          <TextComponent
                            className={styles.value}
                            text={value || "-"}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className={styles.box}>
                  <TextComponent className={styles.Heading} text={"Method"} />
                  <div className={styles.itemsList}>
                    {Object.entries(methodData).map(([label, value]) => {
                      const formattedLabel = label.replace(/_/g, " ");
                      return (
                        <div className={styles.row}>
                          <TextComponent
                            className={styles.label}
                            text={`${formattedLabel} :`}
                          />
                          <TextComponent
                            className={styles.value}
                            text={value || "-"}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className={styles.box}>
                  <TextComponent
                    className={styles.Heading}
                    text={"Additional Parameter"}
                  />
                  <div className={styles.itemsList}>
                    {Object.entries(additionalData).map(([label, value]) => {
                      const formattedLabel = label.replace(/_/g, " ");
                      return (
                        <div className={styles.row}>
                          <TextComponent
                            className={styles.label}
                            text={`${formattedLabel} :`}
                          />
                          <TextComponent
                            className={styles.value}
                            text={value || "-"}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className={styles.rightCont}>
                <div className={styles.box}>
                  <TextComponent
                    className={styles.Heading}
                    text={"Instructions"}
                  />
                  <div className={styles.itemsList}>
                    {Object.entries(instructionsData).map(([label, value]) => {
                      const formattedLabel = label.replace(/_/g, " ");
                      return (
                        <div className={styles.inLineRow}>
                          <TextComponent
                            className={styles.instructionslabel}
                            text={`${formattedLabel} `}
                          />
                          <TextComponent
                            className={styles.instructionsvalue}
                            text={value || "-"}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        {selectedBtn === "btn3" && (
          <>
            <div className={styles.box}>
              <div>
                  <Table
              scroll={{ x: true }}
              columns={finishedColumn}
              dataSource={finishedData}
              pagination={false}
            />
                {/* {finishedData.map((i) => {
                  return (
                    <div className={styles.row}>
                      <TextComponent className={styles.label} text={i.label} />
                      <TextComponent
                        className={styles.value}
                        text={i.type || "-"}
                      />
                      <TextComponent
                        className={styles.value}
                        text={i.value || "-"}
                      />
                    </div>
                    <div className={styles.row}> 
                  
</div>
                  );
                })} */}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default RecipeComponent;
